import { call, put } from 'redux-saga/effects';
import { setTeamAnalyticData } from '../../../../state/analytic/analyticTeamDataSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchTeamDataSaga(action) {
    const { teamId, range, startDate, endDate } = action.payload || {};
    try {
        const params = { range };
        if (range === 'custom' && startDate && endDate) {
            params.startDate = new Date(startDate).toISOString();
            params.endDate = new Date(endDate).toISOString();
        }
        const { data } = yield call(
            [backendClient, backendClient.get],
            `analytics/teams/${encodeURIComponent(teamId)}`,
            { params }
        );
        yield put(setTeamAnalyticData({
            teamId,
            range,
            calls: data?.calls || [],
            members: data?.members || [],
            selfExcluded: data?.selfExcluded ?? false,
        }));
    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to fetch team analytic data', status, err?.message);
    }
}
